import store from '../../state/store'
import * as AT from '../../state/actions/_types'
import { setCurrentUser, setUserAuthorizations } from '../../state/actions/account'
import configureRequest from './configure-request'
import wrapError from './wrap-error'
import tokenStorage from '../token-storage'

const { REACT_APP_API_BASE_URL } = process.env
/**
 * @param options, {Object} a collection of named options
 *   @param body, {String} JSON version of request body
 *   @param isUrlVerbatim, {Boolean} if true, url in `fetch` will be interpreted
 *   verbatim. If false, then you're probably trying to hit a standard route on
 *   the backend API. By default it's false.
 *   But you'd pass true if you want to hit a route or url that's outside
 *   of the usual pattern.
 */
export default (route, verb, {
  body = '',
  isUrlVerbatim = false,
  fetchController = null,
} = {}) => {
  const url = isUrlVerbatim ?
    route :
    `${REACT_APP_API_BASE_URL}/api/v1${route}`

  let config = configureRequest(verb, body)

  if (fetchController) {
    config = { ...config, signal: fetchController.signal }
  }

  return fetch(url, config).then((response) => {
      if (response.status === 401) {
        tokenStorage.clear()
        store.dispatch(setCurrentUser({}))
        store.dispatch(setUserAuthorizations({}))
        store.dispatch({ type: AT.ACCT_FETCHED })
      }
      if (!response.ok) {
        return wrapError(response)
      }
      return response.status === 204 ? // no response body causes problems
          {} :
          response.json()
    })
  // catch errors from the receiver, otherwise this method swallows it!
}



// WEBPACK FOOTER //
// ./src/services/fetchApi/index.js